import type { ElectricalController } from "building-types/electrical/electricalDeviceTypes";
import type { LegacyRoomLayoutElectrical } from "building-types/electrical/electricalLegacyRoomLayoutTypes";
import type { Table } from "common/data/table";
import type { ExplicitControllerSelectionFunc } from "../electricalLayoutTypes";

interface ControllerSelectionExplicitFromRoomBlockDocInfo {
  readonly roomLayoutElectrical: Table<LegacyRoomLayoutElectrical>;
  readonly explicitControllerSelectionFunc: ExplicitControllerSelectionFunc;
  readonly electricalControllers: Table<ElectricalController>;
}

export function controllerSelectionExplicitFromRoomBlockDoc({
  roomLayoutElectrical,
  explicitControllerSelectionFunc,
  electricalControllers,
}: ControllerSelectionExplicitFromRoomBlockDocInfo) {
  for (const roomId in roomLayoutElectrical) {
    const roomGroups = roomLayoutElectrical[roomId];
    if (roomGroups && roomGroups.embeddedGroups) {
      const groups = roomGroups.embeddedGroups;
      for (const group of groups) {
        const { controllers } = group;
        for (const { selections } of controllers) {
          explicitControllerSelectionFunc(selections);
        }
      }
    }
  }

  // new simplified electrical
  for (const controllerId in electricalControllers) {
    const controller = electricalControllers[controllerId];
    explicitControllerSelectionFunc(controller.selections);
  }
}
